import { render, staticRenderFns } from "./teacherCardBalanceLog.vue?vue&type=template&id=188fbfdd&scoped=true&"
import script from "./teacherCardBalanceLog.vue?vue&type=script&lang=js&"
export * from "./teacherCardBalanceLog.vue?vue&type=script&lang=js&"
import style0 from "./teacherCardBalanceLog.vue?vue&type=style&index=0&id=188fbfdd&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188fbfdd",
  null
  
)

export default component.exports